import { takeLatest, select } from 'redux-saga/effects';
import { chatModuleInstanceSelector } from '../selectors';
import chatConsts from '../constants';

function* disconnectWorker() {
  const state = yield select();
  const chatModuleInstance = chatModuleInstanceSelector(state);

  // eslint-disable-next-line no-unused-expressions
  chatModuleInstance && chatModuleInstance.disconnect();
}

export default function* disconnectSaga() {
  yield takeLatest([chatConsts.DISCONNECT], disconnectWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/disconnect.js